import { EXTERNAL_SHIP_FROM_PREFIX } from '../../store/csw/csw.fulfillment-plan-to-csw';

export const setupExternalShipFromIdForContext = (id) => `${EXTERNAL_SHIP_FROM_PREFIX}${id}`;
